export default __webpack_public_path__ + "assets/images/e98c5c14c4e0bc056e6ab5abe350d39d.png";